import { Component, HostListener, Input } from '@angular/core';
import { MatDialog, MatSnackBar } from '@angular/material';

import { ConfirmDialogButtonBase } from '../../shared/base/confirm-dialog-button-base';
import { MESSAGE_COMMON_ERROR } from '../../shared/message';
import { Course } from '../shared/course';
import { MESSAGE_CANNNOT_ENROLL_COURSE_ERROR, MESSAGE_ENROLL_COURSE_SUCCESS } from '../shared/course-message';
import { CourseUserService } from '../shared/course-user.service';

@Component({
  selector: 'app-course-enroll-button',
  template: '<ng-content></ng-content>'
})
export class CourseEnrollButtonComponent extends ConfirmDialogButtonBase {
  @Input() course: Course;

  constructor(dialog: MatDialog, snackBar: MatSnackBar, private service: CourseUserService) {
    super(dialog, snackBar);
  }

  @HostListener('click') onClick() {
    const course = Object.assign(new Course(), this.course);
    if (course.isInProgress()) {
      this.openDialog();
    } else {
      this.openSnackBar(MESSAGE_CANNNOT_ENROLL_COURSE_ERROR);
    }
  }

  openDialog(): void {
    super.openDialog('수강 신청', `${this.course.name} 강좌에 수강 신청하시겠습니까?`, '신청', '취소');
  }

  async onSubmit() {
    try {
      await this.service.addUser(this.course);
      this.closeDialog();
      this.openSnackBar(MESSAGE_ENROLL_COURSE_SUCCESS);
    } catch (e) {
      this.openSnackBar(MESSAGE_COMMON_ERROR);
    }
  }
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/courses/course-enroll-button/course-enroll-button.component.ts